export const LOCAL_STORAGE_SLAP_AD_TRAVEL = 'travel__slapAdClosed';

export const useSlapAdsTravelClosed = () => {
  const slapAdClosed = localStorage.getItem(LOCAL_STORAGE_SLAP_AD_TRAVEL);
  return slapAdClosed;
};
